var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.235,
    cy: 17.235,
    r: 17.235,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2352 11.0469C15.9464 11.0484 14.7108 11.561 13.7995 12.4724C12.8882 13.3837 12.3755 14.6192 12.374 15.908C12.3725 16.9612 12.7165 17.9859 13.3533 18.8247C13.3533 18.8247 13.4859 18.9993 13.5076 19.0245L17.2352 23.4207L20.9646 19.0223C20.984 18.9988 21.117 18.8247 21.117 18.8247L21.1175 18.8234C21.754 17.9849 22.0978 16.9607 22.0963 15.908C22.0948 14.6192 21.5822 13.3837 20.6709 12.4724C19.7595 11.561 18.524 11.0484 17.2352 11.0469ZM17.2352 17.6757C16.8856 17.6757 16.5438 17.572 16.2531 17.3778C15.9624 17.1836 15.7358 16.9075 15.602 16.5845C15.4683 16.2615 15.4332 15.9061 15.5015 15.5632C15.5697 15.2203 15.738 14.9053 15.9852 14.6581C16.2325 14.4109 16.5474 14.2425 16.8903 14.1743C17.2332 14.1061 17.5886 14.1411 17.9116 14.2749C18.2347 14.4087 18.5107 14.6353 18.705 14.926C18.8992 15.2166 19.0029 15.5584 19.0029 15.908C19.0023 16.3767 18.8159 16.8259 18.4845 17.1573C18.1531 17.4887 17.7038 17.6751 17.2352 17.6757Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.3e447b7ba1b501e92eab345e62b76eaf.svg";
export { ForwardRef as ReactComponent };